import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Resolver } from 'react-hook-form';

export interface IAddCultureForm {
  cultureCode: string;
  displayName: string;
}

const schema = yup.object().shape({
  cultureCode: yup
    .string()
    .required('Culture code is required')
    .max(20, 'Culture code must be 20 characters or fewer'),
  displayName: yup
    .string()
    .required('Display name is required')
    .max(100, 'Display name must be 100 characters or fewer'),
});

export default yupResolver(schema) as unknown as Resolver<IAddCultureForm, any>;
